import script from "./EmailDisp.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmailDisp.vue?vue&type=script&setup=true&lang=ts"

import "./EmailDisp.vue?vue&type=style&index=0&id=9c126ac8&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c126ac8"]])

export default __exports__